import { deburr, isUndefined } from "lodash";
// eslint-disable-next-line no-control-regex
const matchNonASCIIChar = /[^\x00-\x7F]/g;
const matchLastDot = /(\.[^.]*$)/;
export const sanitizeFilename = (value) => {
    const defaultFilename = `Uploaded ${new Date().toISOString()}`;
    const sanitizedFilename = deburr(value)
        .replaceAll(",", "")
        .replace(matchNonASCIIChar, "");
    const [filename, extension] = sanitizedFilename.split(matchLastDot, 2);
    if (isUndefined(filename) || isUndefined(extension)) {
        throw new Error("Seems like you are trying to upload a file without an extension.");
    }
    return (filename.length === 0 ? defaultFilename : filename) + extension;
};
//# sourceMappingURL=sanitizeFilename.js.map